import { stopScreenSharing, updateInputOutputDevices } from '../handlers';
import JitsiMeetJS from '../lib-jitsi-meet';
import { getLocalTrack, useTracksStore } from '../store/tracks';
import { getMediaType } from '../utils';

export function onTrack(track: any) {
  if (track.isLocal()) {
    updateInputOutputDevices(true);
    const muted = getLocalTrack(track.getType())?.muted;
    useTracksStore.getState().updateLocalTrack(getMediaType(track), {
      originalTrack: track,
      ...(track.getVideoType() === 'desktop'
        ? {
            muted: 0,
          }
        : typeof muted === 'boolean'
          ? { muted }
          : {}),
    });
    track.on(JitsiMeetJS.events.track.LOCAL_TRACK_STOPPED, (t: any) => {
      if (t.getVideoType() === 'desktop') {
        stopScreenSharing();
      }
    });
  } else {
    useTracksStore.getState().addTrack(track);
  }

  // Remove existing listeners before adding new ones to prevent memory leaks
  // This can happen during P2P to JVB transitions when tracks are re-added
  track.removeAllListeners(JitsiMeetJS.events.track.TRACK_MUTE_CHANGED);
  track.removeAllListeners(JitsiMeetJS.events.track.TRACK_VIDEOTYPE_CHANGED);

  track.on(JitsiMeetJS.events.track.TRACK_MUTE_CHANGED, (t: any) => {
    if (t.isLocal()) {
      return;
    }
    useTracksStore.getState().updateTrack(t, {
      muted: t.isMuted() ? 1 : 0,
    });
  });
  track.on(
    JitsiMeetJS.events.track.TRACK_VIDEOTYPE_CHANGED,
    (type: 'desktop' | 'camera') => {
      useTracksStore.getState().updateTrack(track, {
        videoType: type,
        mediaType: type === 'desktop' ? 'screenshare' : 'video',
      });
    },
  );
}
